<template>
	<div>
		<textInput
			type="text"
			:val="date"
			:leading="leading"
			:placeholder="(placeholder=='') ? label : placeholder"
			:label="label"
			:input_style="input_style"
			class="custom-input"
			:textClass="textClass"
			:valid="valid"
			:id_input="'calender_'+random_id"
		/>
		<date-picker
			v-model="date"
			format="jYYYY/jMM/jDD"
			display-format="jYYYY/jMM/jDD"
			:custom-input="'#calender_'+random_id"
			@input="inputTxt($event)"
			v-if="!disabled"
		/>
	</div>
</template>
<script>
	import textInput from  "../../UI/input/textInput.vue";
	export default {
		name: 'inputcalendar',
		data(){
			return {
				random: parseInt(Math.random()*1000),
			}
		},
		components: {
			textInput,
		},
		props: {
			random_id:{
				default: '',
			},
			disabled:{
				default: false,
			},
			date:{
				default: "",
			},
			input_style:{
				default: "",
			},
			textClass:{
				default: "",
			},
			valid:{
				default: "-1", 
			},
			label:{
				default: "تاریخ تولد", 
			},
			placeholder:{
				default: "تاریخ تولد", 
			},
			leading:{
				default: "روز، ماه و سال تاریخ تولد خود را  بر روی تقویم مشخص کنید.", 
			},
		},
		mounted(){
			if(this.random_id == ''){
				this.random_id = this.random;
			}
		},
		methods:{
			//_______________________________________________________________________
			inputTxt(e){
				if(!this.disabled) this.$emit('inputdate', e);
			}
			//________________________________________________________________________
		}
	}
</script>
<style>
	.highlighted {
		background-color: #fc9e00;
		border-radius: 50%;
	}
	.vpd-day-text{
		font-family: 'yekan';
	}
</style>
